import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { Breakpoint, Color, FontWeight, FormSectionContainerGrid } from '../../enums';
import { StyledComponent } from '../../interfaces';

import { ContainerProps, SectionTitleProps } from './formSection.types';

const ContainerStyles: { [b in FormSectionContainerGrid]: FlattenSimpleInterpolation } = {
  [FormSectionContainerGrid.Standard]: css`
    max-width: 1000px;
  `,
  [FormSectionContainerGrid.Wide]: css`
    max-width: 1200px;
  `
};

export const Container: StyledComponent<'div', ContainerProps> = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  flex-direction: ${({ $desktopRowPosition }: ContainerProps): string => $desktopRowPosition === 'horizontal' ? 'row' : 'column'};

  ${({ $containerGrid }: ContainerProps): FlattenSimpleInterpolation => ContainerStyles[$containerGrid]};

  @media ${Breakpoint.Mobile} {
    flex-direction: column;
  }
`;

export const SectionTitle: StyledComponent<'div', SectionTitleProps> = styled.div<SectionTitleProps>`
  font-weight: ${FontWeight.Medium};
  font-size: 18px;
  line-height: 26px;
  color: ${Color.Black};
  margin-right: 40px;
  margin-bottom: 32px;
  width: 260px;
  margin-right: ${({ $desktopRowPosition }: SectionTitleProps): string => $desktopRowPosition === 'horizontal' ? '40px' : '0'};
  margin-bottom: ${({ $desktopRowPosition }: SectionTitleProps): string => $desktopRowPosition === 'vertical' ? '32px' : '0'};

  @media ${Breakpoint.Tablet} {
    width: 220px;
  }

  @media ${Breakpoint.Mobile} {
    margin-bottom: 24px;
    width: 100%;
  }

  @media ${Breakpoint.SmallMobile} {
    margin-right: 0;
  }
`;

export const SectionContent: StyledComponent<'div'> = styled.div`
  width: 100%;
  max-width: 740px;
  padding-top: 8px;

  @media ${Breakpoint.Tablet} {
    padding-top: 0;
  }
`;
